import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Heart } from 'lucide-react';
import { listingsAPI } from '@/lib/api';
import { ListingCard } from '@/components/listings/ListingCard';
import { useListingGrid } from '@/hooks/useListingGrid';

const DashboardLikedItemsTab = () => {
    const [likedListings, setLikedListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const { gridSettings, singleColumn } = useListingGrid();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const likesRes = await listingsAPI.getMyLikes();
                setLikedListings(likesRes.data || []);
            } catch (error) {
                console.error('Error fetching liked listings:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="space-y-4">
                <Skeleton className="h-10 w-full" />
                <div 
                    className="grid gap-4 category-grid"
                    style={{
                        '--grid-cols-mobile': gridSettings.mobile,
                        '--grid-cols-tablet': gridSettings.tablet,
                        '--grid-cols-desktop': gridSettings.desktop,
                    }}
                >
                    {[...Array(4)].map((_, i) => (
                        <Skeleton key={i} className="h-72" />
                    ))}
                </div>
            </div>
        );
    }

    return (
        <Card className="rounded-2xl">
            <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-2">
                    <Heart className="w-5 h-5 text-red-500 fill-current" />
                    Apreciate
                </CardTitle>
                <CardDescription>
                    {likedListings.length} listări apreciate
                </CardDescription>
            </CardHeader>
            <CardContent>
                {likedListings.length === 0 ? (
                    <div className="text-center py-12 text-muted-foreground">
                        <Heart className="w-12 h-12 mx-auto mb-4 opacity-30" />
                        <p>Nu ai apreciat nicio listare încă</p>
                        <p className="text-sm mt-2">Apasă pe inimă pentru a salva listările preferate</p>
                    </div>
                ) : (
                    <div 
                        className="grid gap-4 category-grid"
                        style={{
                            '--grid-cols-mobile': gridSettings.mobile,
                            '--grid-cols-tablet': gridSettings.tablet,
                            '--grid-cols-desktop': gridSettings.desktop,
                        }}
                    >
                        {likedListings.map((listing) => (
                            <ListingCard
                                key={listing.listing_id}
                                listing={listing}
                                singleColumn={singleColumn}
                            />
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default DashboardLikedItemsTab;
